import { Badge, type BadgeProps, styled } from '@mui/material';

const NotificationNumberBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -15,
    top: 13,
    padding: '0 4px',
    color: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white,
  },
}));

export default NotificationNumberBadge;
